import script from "./ProductsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsTable.vue?vue&type=script&setup=true&lang=js"

import "./ProductsTable.vue?vue&type=style&index=0&id=517b4a8f&scoped=true&lang=css"
script.__scopeId = "data-v-517b4a8f"

export default script